import { useEffect, useState } from 'react';
import { useEntryContext } from '../../context';
import { useDebouncedValue } from '@mantine/hooks';
import { useStore } from '@/store';

export const useFooter = (value: string | undefined) => {
  /* Context State */
  const [id, setCode] = useEntryContext((s) => [s.getId(), s.setCode]);
  // FIXME: Using getComputed through the API results in a delayed refresh of the output.
  // This is happening in other parts of the codebase as well most likely, see what can be done about this.
  const computed = useStore(({ entries: e }) => e.getComputed(id));
  /* Local State */
  const [output, setOutput] = useState<string>('');
  const [debounced] = useDebouncedValue(value, 500);

  const isValid = (input: string) => {
    try {
      JSON.parse(input);
      return true;
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    if (value === undefined) return;
    if (!isValid(value)) return;

    setCode(JSON.parse(value));
  }, [debounced]);

  useEffect(() => {
    if (computed === undefined) return;
    if (computed === null) return;

    setOutput(computed);
  }, [computed]);

  return { output };
};
